import * as $ from "jquery";
import * as ko from "knockout";

// Services
import { ClubSelectionCacheServices } from "Content/ts/Shared/ClubSelector/Services/clubSelectionCacheServices";

export const Deps = {
    ClubSelectionCacheServices: new ClubSelectionCacheServices()
}

export module HomeClubBindings {
    ko.bindingHandlers.isHomeClubDisabled = {
        init: (element: any) => {
            $(element)
                .attr("aria-live", "polite")
                .attr("aria-hidden", "true")
                .hide();
            
            Deps.ClubSelectionCacheServices.IsHomeClubDisabled()
                .then((response: boolean) => {
                    if (!response) {
                        $(element)
                            .attr("aria-hidden", "false")
                            .show();
                    }
                });
        }
    };
}